import axios from 'axios';
import { useMutation, useQueryClient } from 'react-query';
import { useContext } from 'react';
import { AuthContext } from '../../Context/AuthContext';

const useUnmarkDeal = () => {
  const { token } = useContext(AuthContext);
  const queryClient = useQueryClient();

  const mutation = useMutation(
    ({ productId, type }) =>
      axios.patch(
        `${process.env.REACT_APP_SERVER_URL}/product/products/${productId}/deal`,
        { type, active: false },
        { headers: { Authorization: `Bearer ${token}` } }
      ),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('products');
      },
    }
  );

  return {
    unmarkDeal: mutation.mutateAsync,
    isLoading: mutation.isLoading,
  };
};

export default useUnmarkDeal;
